export default "__VITE_ASSET__7c4ffd0c__"